import { AlertTriangle } from "lucide-react";
import {
  Alert,
  AlertDescription,
  AlertTitle,
} from "@/shared/components/ui/alert";
import t from "@/lang/lang";

export function AlertNotReleased() {
  return (
    <Alert variant="destructive">
      <AlertTriangle />
      <AlertTitle>{t("Not released")}</AlertTitle>
      <AlertDescription>
        {t("Dieses Feature wurde noch nicht veröffentlicht.")}
      </AlertDescription>
    </Alert>
  );
}
